<main class="main">
    <div class="main-wrapper">
        <section class="padding-first about1" id="about_us">
        <div class="container">

	        <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
	            <div class="icon-back">
	                <span>Back</span>
	            </div>
	        </a>

	        <div>
	          	<div class="bl-rows">
		            <div class="text">
		                <h2>novae, now member of Visa Fintech Partner Connect</h2>
                        <p>In sync with the release of the fintech company’s most revolutionary app to <strong>date—Miles</strong> Blue.</p>
		                <span>By <strong>novae</strong> September 13, 2021</span>
		            </div>
		            <div class="img">
		                <img src="./assets/img/gennius/bg-inside-notice3.png">
		            </div>
	          	</div>
	        </div>

	          	<div class="bl-center">

		            <p>novae is now part of <strong>Visa Fintech Partner Connect</strong>, a program designed to leverage Visa’s issuing clients by quickly connecting them to a vetted set of technology partners. As a conclusion of several years of successful solution releases in partnership with Visa, novae has now been officially recognized as a leading fintech partner in the acceleration of disruptive technologies that fit within Visa’s vision of digital innovation.</p>

                    <div class="text-1"><span>“We've actually just jumped on the wagon of the Visa FinTech partner Connect, which is very exciting for us since we’ve always showcased our solutions and capabilities in partnership with Visa’s platform”, explained Rodrigo McCarthy, Head of Payments at novae.</span></div>

                    <p>novae’s relationship with Visa has consistently grown since the inception of their first disruptive loyalty program, Visa Loyalty Solutions, in 2018. Since then, the continuous release of successful platforms has placed novae at the forefront of disruptive solutions that have consistently delivered outstanding business outcomes.</p>

                    <p>Now, with the release of their most revolutionary <strong>Super App as a Service, Miles Blue</strong>, novae has embarked on a journey to connect users with banks, airlines, insurance companies and millions of merchants via built-in rewards and embedded finance features. Users can now unlock the power of their digital assets by earning and redeeming using 80+ cryptocurrencies while combining debit and credit cards, multiple rewards programs and crypto, all into one digital currency.</p>

                    <p>This disruptive solution provides the ability to redeem rewards at over <strong>70+ million merchants around the world. Miles Blue </strong>users can also pay via contactless using all major e-wallets, and even instantly pay and get paid combining currencies and rewards — features highly desired in today’s gig economy where professionals and business owners have become remote. This solution also comes with a completely enhanced travel experience, allowing users to get <strong>28+ million flight, hotel or car rental options</strong> at exclusive rates and earn up to 5X rewards upon redeeming rewards.
                    </p>

                    <div class="text-1"><span>“We want our banks to have the best digital super app experience [...] available on the market. Some banks can do that on their own. But many banks need help to find the right partners to enable them to bring their digital banking experience up to where I think many fintechs are today” said Terry Angelos, Global Head of FinTech at Visa, Inc.</span></div>

                    <p>By streamlining fintech discovery, supporting exclusive commercial packages and endorsing members of the <strong>Visa Fintech Partner Connect</strong> program, Visa keeps bringing new capabilities and solutions in line with cardholder's needs and the evolution of the consumer market around the globe.
                    </p>

                    <p class="foot">To learn more about this agreement, please read novae’s member page in the Visa Fintech Partner Connect website: <a href="https://partner.visa.com/site/partner-directory/novae.html" target="_blank">https://partner.visa.com</a> 

                    </p>

                    <p class="foot">Visa Inc. (NYSE: V) is a leading digital payment company. Its mission is to connect the world through the most innovative, reliable and secure payment network that empowers people, businesses and economies to thrive. Their advanced global processing network is capable of handling more than 65,000 transaction messages per second.</p>


	          	</div>

        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>
